const modalBtns = document.querySelectorAll('.modal-btn');
const modalClose = document.querySelectorAll('.modal-close');

modalBtns.forEach(function(entry) {
    entry.addEventListener('click',function(){

        let modalBg = document.querySelector('#' + entry.dataset.modalId);
        modalBg.classList.add('bg-active');
    });
});

modalClose.forEach(function(entry) {
    entry.addEventListener('click',function(){
        let modalBg = document.querySelector('#' + entry.dataset.modalId);
        modalBg.classList.remove('bg-active')

    });
});
